import Vue from 'vue';
import 'intersection-observer';

const options = {
  root: null,
  rootMargin: '0px',
  threshold: 0,
};
const exposureTask: number[] = [];

Vue.directive('expose', {
  bind(el, binding) {
    const data = binding.value;

    new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (exposureTask.includes(data.id)) return;
          if (data.bid) {
            data.callback(data.bid, data.params);
          } else {
            data.callback();
          }
          exposureTask.push(data.id);
        }
      });
    }, options).observe(el);
  },
});
